/**
 * A "copy this shell command" button.
 *
 * Mantine's CopyButton goes through navigator.clipboard, which is absent
 * on a plain-http origin (a LAN demo, a tailnet name). The textarea +
 * execCommand path still works there, so it is the fallback.
 */

import { Button, CopyButton } from "@mantine/core";
import { IconCopy } from "@tabler/icons-react";

export function copyTextWithFallback(text: string, copy: () => void): void {
  try {
    copy();
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.left = "-9999px";
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    document.body.removeChild(ta);
  }
}

interface CopyCommandButtonProps {
  value: string;
  label?: string;
  size?: "xs" | "sm" | "md";
}

export function CopyCommandButton({ value, label = "Copy", size = "xs" }: CopyCommandButtonProps) {
  return (
    <CopyButton value={value}>
      {({ copied, copy }) => (
        <Button
          size={size}
          variant={copied ? "filled" : "light"}
          color={copied ? "teal" : "blue"}
          leftSection={<IconCopy size={14} />}
          onClick={() => copyTextWithFallback(value, copy)}
        >
          {copied ? "Copied!" : label}
        </Button>
      )}
    </CopyButton>
  );
}
